<template>
  <v-navigation-drawer
    class="elevation-8"
    disable-resize-watcher
    :width="rightSidebarWidth"
    right
    absolute
    stateless
    hide-overlay
    v-model="showCatalogue"
    color="whitesmoke"
  >
    <v-toolbar
      flat
      style="position: -webkit-sticky; /* Safari */position: sticky; z-index: 3"
    >
      <v-btn icon @click="hideCatalogueDrawer">
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-toolbar-title>Kartkatalog</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>

    <v-text-field
      v-model="search"
      label="Søk i kartkatalogen.."
      flat
      box
      single-line
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
    ></v-text-field>
    <p class="secondary pl-3 pr-4 pt-2 pb-2 mb-0">
      Dra kartlag fra kartkatalogen og slipp i kartet for å legge til.
    </p>
    <v-sheet
      class="mx-auto"
      style="overflow-y: scroll; height: calc(100% - 158px); overflow-x: auto"
      height="100%"
    >
      <v-treeview
        class="pa-2"
        item-text="title"
        return-object
        :search="search"
        open-on-click
        :items="categoriesSortedAsArray"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="item.children">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          <v-icon v-else>
            mdi-layers-outline
          </v-icon>
        </template>

        <template v-slot:label="{ item }">
          <label v-if="item.children">
            <span class="body-1">{{ item.title }}</span>
          </label>
          <label v-else draggable @dragstart="startDrag($event, item)">
            <span class="caption">{{ item.title }}</span>
          </label>
        </template>
      </v-treeview>
    </v-sheet>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfilesMixin from "@/mixins/profilesMixin";
export default {
  name: "LayerCatalogue",
  mixins: [ProfilesMixin],
  computed: {
    ...mapState(["selectedTheme", "favourites", "extent"]),
    rightSidebarWidth() {
      if (this.$vuetify.breakpoint.xlAndUp) {
        return "440";
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return "420";
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        return "350";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "300";
      } else {
        return "300";
      }
    },
    showCatalogue: {
      set(showCatalogue) {
        this.setShowCatalogue(showCatalogue);
      },
      get() {
        return this.$store.state.showCatalogue;
      },
    },
  },
  data: function() {
    return {
      categoriesSortedAsArray: [],
      test: [],
      search: null,
      loaded: false,
    };
  },
  watch: {
    showCatalogue(newVal) {
      if (newVal && !this.loaded) {
        this.categoriesSortedAsArray = this.getCategoriesSortedAsArray();
        this.loaded = true;
      }
    },
    categoriesSorted() {
      this.categoriesSortedAsArray = this.getCategoriesSortedAsArray();
      this.loaded = true;
    },
  },
  methods: {
    ...mapActions(["addFavourite", "removeFavourite", "setShowCatalogue"]),
    hideCatalogueDrawer() {
      this.setShowCatalogue(false);
    },
    startDrag: (evt, item) => {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("mapProfile", JSON.stringify(item));
    },
    getCategoriesSortedAsArray: function() {
      let categoriesSortedAsArray = [];
      if (this.categoriesSorted) {
        for (let key in this.categoriesSorted) {
          let treeNode = {
            id: key,
            title: key,
            children: [],
          };
          if (key === "Ukategorisert") {
            continue;
          }
          for (let subKey in this.categoriesSorted[key]) {
            let child = {
              id: subKey,
              ...this.categoriesSorted[key][subKey],
            };
            if (
              !child.test &&
              (key !== "Ukategorisert" ||
                this.categoriesSorted[key][subKey].onlyAllowAddingFromDialog)
            ) {
              treeNode.children.push(child);
            }
          }

          categoriesSortedAsArray.push(treeNode);
        }

        return categoriesSortedAsArray;
        // return this.categoriesSorted;
      } else {
        setTimeout(() => {
          this.categoriesSortedAsArray = this.getCategoriesSortedAsArray();
        }, 1000);
        return categoriesSortedAsArray;
      }
    },
  },
  created() {},
};
</script>

<style></style>
